import React, { useContext } from 'react';
import { Divider, Tooltip, useTheme } from '@mui/material';
import { DeleteForever, Loop, Settings, Star } from '@mui/icons-material';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  CurrentlyViewingActions,
  CurrentlyViewingButton,
  CurrentlyViewingWrapper,
  DropdownInnerContent,
  EmptyStar,
  DropdownLabel,
} from './style';
import useSavedDatasets from '../../../hooks/useSavedDatasets';
import DataLoaderContext from '../../../contexts/DataLoaderContext';

function CurrentlyViewingSection({
  currentDataSetName,
  onDatasetLoadClick,
  openDeleteDatasetDialog,
  onFavoriteDatasetClick,
  openDataLoader,
}) {
  const { filteredStrippedDatasets } = useSavedDatasets();
  const { setTrigger } = useContext(DataLoaderContext);
  const intl = useIntl();
  const theme = useTheme();
  const iconColor = theme.palette.text.secondary;

  const currentDataset = filteredStrippedDatasets?.find(
    (dataset) => dataset.name === currentDataSetName
  );
  const { uuid, favorite } = currentDataset;

  const favoriteIcon = () =>
    favorite ? <Star fontSize="small" color="warning" /> : <EmptyStar fontSize="small" />;

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    onFavoriteDatasetClick(uuid);
  };

  const handleDatasetClick = () => onDatasetLoadClick(uuid);

  const handleManageClick = () => {
    setTrigger('Dropdown');
    openDataLoader('manage', {
      uuid,
      loadState: 'edit',
    });
  };

  const handleDeleteClick = () => openDeleteDatasetDialog(uuid, currentDataSetName);

  const iconButtonProperties = [
    {
      key: 'star-icon-button',
      disabled: false,
      icon: favoriteIcon(),
      tooltip: intl.formatMessage({
        id: 'loadData.menu.currentDataset.tooltip.favorite',
        defaultMessage: 'Favorite',
      }),
      onClick: handleFavoriteClick,
    },
    {
      key: 'reload-icon-button',
      disabled: false,
      icon: <Loop fontSize="small" fill={iconColor} />,
      tooltip: intl.formatMessage({
        id: 'loadData.menu.currentDataset.tooltip.reload',
        defaultMessage: 'Reload',
      }),
      onClick: handleDatasetClick,
    },
    {
      key: 'edit-icon-button',
      icon: <Settings fontSize="small" fill={iconColor} />,
      tooltip: intl.formatMessage({
        id: 'loadData.menu.currentDataset.tooltip.edit',
        defaultMessage: 'Edit',
      }),
      onClick: handleManageClick,
    },
    {
      key: 'delete-icon-button',
      icon: <DeleteForever fontSize="small" fill={iconColor} />,
      tooltip: intl.formatMessage({
        id: 'loadData.menu.currentDataset.tooltip.delete',
        defaultMessage: 'Delete',
      }),
      onClick: handleDeleteClick,
    },
  ];

  return (
    <CurrentlyViewingWrapper value="Example Data" disabled>
      <DropdownLabel variant="caption">
        <FormattedMessage
          id="loadData.menu.currentDataset.header"
          defaultMessage="Currently Viewing"
        />
      </DropdownLabel>
      <DropdownInnerContent variant="body2">{currentDataSetName}</DropdownInnerContent>
      <CurrentlyViewingActions>
        {iconButtonProperties.map((item) => (
          <Tooltip key={item.key} title={item.tooltip}>
            <span>
              <CurrentlyViewingButton key={item.key} onClick={item.onClick} size="small">
                {item.icon}
              </CurrentlyViewingButton>
            </span>
          </Tooltip>
        ))}
      </CurrentlyViewingActions>
      <Divider />
    </CurrentlyViewingWrapper>
  );
}

export default CurrentlyViewingSection;
